import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';

import Header from 'components/Common/Header';
import Tab from 'components/Common/Tab';
import TextInput from 'components/Common/TextInput';
import Table from 'components/Common/StyledTable';
import { useNavigate } from 'react-router-dom';
import routes from 'constants/routes';
import Button from 'components/Common/Button';
import { RootState, store } from 'redux/store';
import MuiLoader from 'components/Common/Loader';
import { fetchParishMembers } from 'redux/slices/community/parishMemberSlice';
import { Stack, Typography } from '@mui/material';
import { debounce } from 'utils/helpers';
import InviteMemberModal from 'components/Community/InviteMemberModal';

const StyledContainer = styled.div({
    backgroundColor: '#F2F2F6',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
});

const StyledActionContainer = styled.div({
    marginBottom: 16,
    padding: 22,
});

const StyledInnerContainer = styled.div({
    backgroundColor: 'white',
    padding: 1,
    marginTop: 10,
});

const columns = [
    { id: 'firstName', label: 'First Name' },
    { id: 'lastName', label: 'Last Name' },
    { id: 'username', label: 'Username' },
    // { id: 'uuid', label: 'Parishioner ID#' },
    { id: 'status', label: 'Status', render: ({ value }: { value: string }) => value || 'Visitor' },
];

const Community: React.FC = () => {
    const [tab, setTab] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch<typeof store.dispatch>();
    const [searchText, setSearchText] = useState<string>('');
    const [inviteMemberModal, setInviteMemberModal] = useState(false);
    const { parishList, loading } = useSelector((state: RootState) => state.community.perishMembers);

    useEffect(() => {
        searchText && dispatch(fetchParishMembers({ searchText }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, searchText]);

    const navigationHandler = (row: any) => {
        navigate(routes.community.ParishonerDetails.replace(':uuid', row.uuid));
    };

    const handleChangeSearch = debounce((e: any) => {
        const { value } = e.target || {};
        setSearchText(value);
    }, 700);

    return (
        <StyledContainer style={{ borderRadius: 12 }}>
            <MuiLoader loading={loading} absolute />
            <div style={{ padding: 22 }}>
                <Header />
            </div>
            <StyledActionContainer>
                <StyledInnerContainer>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            paddingLeft: 22,
                            flexDirection: 'row',
                            justifyContent: 'space-around',
                        }}
                    >
                        <Tab
                            tabs={[
                                { value: 'parishmembers', label: 'Parish Members' },
                                // { value: 'parishes', label: 'Parishes' },
                            ]}
                            tabValue={tab}
                            setTabValue={setTab}
                        />
                    </div>
                    <Button
                        sx={{ m: 2, width: { xs: '50%', sm: '30%', lg: '20%' }, fontSize: { xs: 14, md: 18 } }}
                        title="Invite New Member"
                        onClick={() => setInviteMemberModal(true)}
                    />
                    <div style={{ padding: 16 }}>
                        <TextInput onChange={handleChangeSearch} />
                    </div>

                    {/* Table for showing data - define the columns and data here. */}
                    {!searchText ? (
                        <Stack justifyContent="center" alignItems="center" minHeight="300px">
                            <Typography>
                                Start typing a name, email, nickname, or parishioner ID# into the search bar above and the results will show
                                here.
                            </Typography>
                        </Stack>
                    ) : (
                        <Table unStyled navigationHandler={navigationHandler} columns={columns} data={parishList} loading={loading} />
                    )}
                </StyledInnerContainer>
            </StyledActionContainer>
            <InviteMemberModal isOpen={inviteMemberModal} onClose={() => setInviteMemberModal(false)} />
        </StyledContainer>
    );
};

export default Community;
